<template>
<div id="meetingPushing">
  <div class="allSearch">
    <div class="newSearch d_flex">
      <div style="width: auto;white-space: normal">
        <p>
          <input @keyup.enter="getList(1)" class="allInput m_r_10 " placeholder="调研ID" type="text" style="" v-model="postData.ResearchNo">
        </p>
        <p>
          <input @keyup.enter="getList(1)" class="allInput m_r_10 " placeholder="调研名称" type="text" style="" v-model="postData.ResearchName">
        </p>
        <p>
          <input @keyup.enter="getList(1)" class="allInput m_r_10 " placeholder="自定义标签" type="text" style="" v-model="postData.CustomTag">
        </p>
        <button class="redButton" @click="getList(1)">搜索</button>
      </div>
    </div>
  </div>
  <div class="allTablePlace">
    <div>
      <table cellspacing="0" class="allTable">
        <thead>
        <tr>
          <th>调研ID</th>
          <th>调研名称</th>
          <th>自定义标签</th>
        </tr>
        </thead>
        <tbody>
        <tr @click="sendSur(item, index)" :style="{'background': selIndex === index ? '#FF7F41' : '','color': selIndex === index ? '#fff' : ''}" class="c_p" :key="index" v-for="(item, index) in myList">
          <td :title="item.researchNo" class="NoWrap" style="max-width: 200px">{{item.researchNo}}</td>
          <td :title="item.researchName" style="max-width: 200px" class="t_l NoWrap">{{item.researchName}}</td>
          <td :title="item.customTag" class="NoWrap" style="max-width: 200px">{{item.customTag}}</td>
        </tr>
        </tbody>
      </table>
    </div>
    <page v-if="totalPage !== 0" v-on:on-getList="getList($event)" :totalCount="totalCount" :totalPage="totalPage" :page="page" :explain="0"></page>
  </div>
  <model v-if="showModel" :buttonType="2" :title="title" :maxHeight="'80vh'" :minWidth="'1200px'" v-on:on-cancel="showModel = false" v-on:on-confirm="showModel = false">
    <div style="width:100%; box-sizing:border-box; padding:10px 40px;">
      <div style="display: inline-block;width: calc(100% - 502px);vertical-align: top">
        <div class="messagePushingStep">
          Step 1.输入调研名称
        </div>
        <div style="justify-content: flex-start" class="d_flex m_t_20">
          <div class="w20 required t_l">调研名称:</div>
          <input v-model="surModel.researchName" class="allInput w60" placeholder="请输入调研名称" type="text" style="">
        </div>
        <div style="margin-top: 20px" class="messagePushingStep">
          Step 2.设置调研标签
        </div>
        <div style="justify-content: flex-start" class="d_flex m_t_20">
          <div class="w20 t_l">BU:</div>
          <input v-model="surModel.bu" class="allInput w60" placeholder="请输入BU" type="text" style="">
        </div>
        <div style="justify-content: flex-start;margin-top: 20px" class="d_flex">
          <div class="w20 t_l">产品:</div>
          <input v-model="surModel.product" class="allInput w60" placeholder="请输入产品" type="text" style="">
        </div>
        <div style="justify-content: flex-start;margin-top: 20px" class="d_flex">
          <div class="w20 t_l">自定义标签:</div>
          <input v-model="surModel.customTag" class="allInput w60" placeholder="请输入自定义标签" type="text" style="">
        </div>
        <div style="margin-top: 20px" class="messagePushingStep">
          Step 3.添加/修改问题
        </div>
        <div style="justify-content: flex-start;margin-top: 20px" class="d_flex">
          <div class="w20 required t_l">类型:</div>
          <input v-model="questionModel.subjectType" value="单选" type="radio" class="allRadio" id="radio2" name="radio2"/>
          <label for="radio2"></label><abbr>单选题</abbr>
          <input v-model="questionModel.subjectType" value="多选" type="radio" class="allRadio" id="radio3" name="radio2"/>
          <label style="margin-left: 20px" for="radio3"></label><abbr>多选题</abbr>
          <input v-model="questionModel.subjectType" value="问答" type="radio" class="allRadio" id="radio4" name="radio2"/>
          <label style="margin-left: 20px" for="radio4"></label><abbr>问答题</abbr>
        </div>
        <div style="justify-content: flex-start;" class="d_flex m_t_10">
          <div class="w20 required t_l">问题描述:</div>
          <input v-model="questionModel.desc" class="allInput w60" placeholder="请输入问题描述" type="text" style="">
          <span v-if="questionModel.subjectType !== '问答' && questionModel.items.length !== 5" @click="addNewItem" class="addSeuItem">+</span>
        </div>
        <div v-if="questionModel.subjectType !== '问答'">
          <div :key="index" v-for="(item, index) in questionModel.items" style="justify-content: flex-start;" class="d_flex m_t_10">
            <div class="w20 t_l"><span class="required" style="padding-left: 20px">{{ item.itemKey }}</span></div>
            <input v-model="item.itemValue" class="allInput w60" type="text" style="">
            <span @click="redusItem(index)" v-if="index !== 0" class="addSeuItem cancel">-</span>
          </div>
        </div>
        <div v-if="questionModel.subjectType === '问答'">
          <div style="justify-content: flex-start;" class="d_flex m_t_10">
            <div class="w20 t_l"></div>
            <textarea name="" style="padding: 5px" id="" disabled class="allTextarea w60" cols="30" rows="10"></textarea>
          </div>
        </div>
      </div>
      <div style="display: inline-block;width: 500px;vertical-align: top">
        <div style="border-radius: 10px; border: 1px solid #eee;padding: 10px;min-height: 500px;max-height: 500px;overflow: auto">
          <div :key="index" v-for="(item, index) in surModel.subjects" class="d_flex allSelectedMember m_t_10">
            <div @click="editItemIndex(item, index)" class="w80 c_p t_l"><span>{{item.subjectType}}</span> <span  style="margin:0 5px">|</span> <span>{{ item.desc }}</span></div>
            <div>
              <span v-if="index !== 0" @click="upQuestionItem(index)" style="transform: rotate(180deg);display: inline-block" class="icon c_p iconfont f_w iconarrow">
              </span>
              <span v-if="index !== surModel.subjects.length - 1" @click="downQuestionItem(index)" class="icon c_p iconfont m_l_10 f_w iconarrow">
              </span>
              <span @click="delQuestionItem(index)" class="icon c_p iconfont m_l_10 f_w iconguanbi">
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="split_2 m_b_20 m_t_20">
        <div v-if="itemIndex === ''">
          <button @click="pushItem" class="redButtonTwo m_r_10 m_l_10">添加</button>
          <button @click="resetItem" class="cancelButtonTwo m_r_10 m_l_10">清空</button>
        </div>
        <div v-if="itemIndex !== ''">
          <button @click="editItem" class="redButtonTwo m_r_10 m_l_10">保存</button>
          <button @click="itemIndex = ''" class="cancelButtonTwo m_r_10 m_l_10">取消</button>
        </div>
        <div class="split2_r">
          <button @click="saveSur" class="redButtonTwo m_r_10 m_l_10">确认</button>
          <button @click="showModel = false" class="cancelButtonTwo m_r_10 m_l_10">取消</button>
        </div>
      </div>
    </div>
  </model>
  <model v-if="showQRModel" :buttonType="2" :title="'查看链接'" :maxHeight="'80vh'" :minWidth="'600px'" v-on:on-cancel="showQRModel = false" v-on:on-confirm="showQRModel = false">
    <div style="width:100%; box-sizing:border-box; padding:10px 40px;">
      <div class="split_2">
        <div>
          <img width="90%" :src="qrmodel.qrCodeData" alt="">
        </div>
        <div style="vertical-align: top">
          <div style="word-break: break-all;border-radius: 10px;padding: 10px;background: #eee">
            <div style="word-break: break-all;white-space: normal">{{qrmodel.url}}</div>
            <div @click="copyLink" class="m_t_10 c_p t_r"><input style="position: fixed;top: -9999px" id="surUrl" :value="qrmodel.url" type="text">复制链接 <i style="color: #F25A7F" class="icon iconfont m_l_10 iconneirongguanli"></i></div>
          </div>
        </div>
      </div>
      <div class="m_b_20 m_t_20">
        <div class="t_c">
          <button @click="downLoadQR" class="redButtonTwo m_r_10 m_l_10">下载二维码</button>
          <button @click="showQRModel = false" class="cancelButtonTwo m_r_10 m_l_10">关闭</button>
        </div>
      </div>
    </div>
  </model>
</div>
</template>

<script>
export default {
  name: 'meetingPushing',
  data () {
    return {
      selIndex: -1,
      qrmodel: {
        qrCodeData: '',
        url: ''
      },
      itemIndex: '',
      showModel: false,
      showQRModel: false,
      postData: {
        ResearchNo: '',
        ResearchName: '',
        Bu: '',
        Product: '',
        CustomTag: '',
        PageIndex: 1,
        PageSize: this.$commonJs.commonPageSize
      },
      title: '',
      messageList: [],
      totalPage: 1,
      totalCount: 0,
      page: 1,
      meeting: {},
      myList: [
      ],
      surModel: {
        id: 0,
        researchNo: '',
        researchName: '',
        bu: '',
        product: '',
        customTag: '',
        subjects: [
        ],
        isShowWujiahuiMeeting: true
      },
      questionModel: {
        desc: '',
        sort: 0,
        subjectType: '单选',
        items: [
          {
            itemKey: 'A',
            itemValue: ''
          },
          {
            itemKey: 'B',
            itemValue: ''
          },
          {
            itemKey: 'C',
            itemValue: ''
          },
          {
            itemKey: 'D',
            itemValue: ''
          }
        ]
      },
      questionArray: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z']
    }
  },
  created () {
    this.getList(1)
  },
  methods: {
    sendSur (item, index) {
      this.selIndex = index
      this.$emit('getSurId', item)
    },
    copyLink () {
      let Url2 = document.getElementById('surUrl')
      Url2.select() // 选择对象
      document.execCommand('Copy')
    },
    base64ToBlob (code) {
      let parts = code.split(';base64,')
      let contentType = parts[0].split(':')[1]
      let raw = window.atob(parts[1])
      let rawLength = raw.length
      let uInt8Array = new Uint8Array(rawLength)
      for (let i = 0; i < rawLength; ++i) {
        uInt8Array[i] = raw.charCodeAt(i)
      }
      return new Blob([uInt8Array], {type: contentType})
    },
    downLoadQR () {
      let aLink = document.createElement('a')
      let blob = this.base64ToBlob(this.qrmodel.qrCodeData)
      let evt = document.createEvent('HTMLEvents')
      evt.initEvent('click', true, true)
      aLink.download = '会议二维码'
      aLink.href = URL.createObjectURL(blob)
      aLink.click()
    },
    copySur (id) {
      this.$axiox.get('/api/Research/detail/' + id).then(p => {
        p.id = 0
        this.surModel = p
        this.showModel = true
        this.title = '复制调研'
      })
    },
    getQRcode (id) {
      this.$axiox.get('/api/Research/qrcode?id=' + id + '&type=0').then(p => {
        this.showQRModel = true
        this.qrmodel = p
      })
    },
    deleteSur (id) {
      this.$commonJs.doubleComfirm({
        content: '是否确定删除此调研？',
        successFun: msg => {
          this.$axiox.get('/api/Research/del/' + id).then(msg => {
            this.$commonJs.alertTips({
              type: 'success',
              title: '成功',
              content: '删除成功',
              stayTime: 5
            })
            this.getList(1)
          })
        },
        errorFun: msg => {
        }
      })
    },
    editSur (item) {
      this.$axiox.get('/api/Research/detail/' + item.id).then(p => {
        this.surModel = JSON.parse(JSON.stringify(p))
        this.showModel = true
        this.title = '编辑调研'
      })
    },
    editItemIndex (item, index) {
      this.itemIndex = index
      this.questionModel = JSON.parse(JSON.stringify(item))
    },
    upQuestionItem (index) {
      let data = JSON.parse(JSON.stringify(this.surModel.subjects[index - 1]))
      let data2 = JSON.parse(JSON.stringify(this.surModel.subjects[index]))
      this.surModel.subjects[index] = data
      this.surModel.subjects[index - 1] = data2
      this.resetItemSort()
      this.$forceUpdate()
    },
    downQuestionItem (index) {
      let data = JSON.parse(JSON.stringify(this.surModel.subjects[index + 1]))
      let data2 = JSON.parse(JSON.stringify(this.surModel.subjects[index]))
      this.surModel.subjects[index] = data
      this.surModel.subjects[index + 1] = data2
      this.resetItemSort()
      this.$forceUpdate()
    },
    delQuestionItem (index) {
      this.surModel.subjects.splice(index, 1)
      this.resetItemSort()
    },
    editItem () {
      this.surModel.subjects[this.itemIndex] = JSON.parse(JSON.stringify(this.questionModel))
      this.itemIndex = ''
      this.questionModel = {
        desc: '',
        sort: 0,
        subjectType: '单选',
        items: [
          {
            itemKey: 'A',
            itemValue: ''
          },
          {
            itemKey: 'B',
            itemValue: ''
          },
          {
            itemKey: 'C',
            itemValue: ''
          },
          {
            itemKey: 'D',
            itemValue: ''
          }
        ]
      }
    },
    pushItem () {
      if (!this.questionModel.desc) {
        return this.$commonJs.alertTips({
          type: 'warning',
          title: '提示',
          content: '请输入问题描述',
          stayTime: 5
        })
      }
      if (this.questionModel.subjectType !== '问答') {
        for (let i = 0; i < this.questionModel.items.length; i++) {
          if (!this.questionModel.items[i].itemValue) {
            return this.$commonJs.alertTips({
              type: 'warning',
              title: '提示',
              content: '请输入选项描述',
              stayTime: 5
            })
          }
        }
      }
      this.surModel.subjects.push(JSON.parse(JSON.stringify(this.questionModel)))
      this.resetItemSort()
      this.questionModel = {
        desc: '',
        sort: 0,
        subjectType: '单选',
        items: [
          {
            itemKey: 'A',
            itemValue: ''
          },
          {
            itemKey: 'B',
            itemValue: ''
          },
          {
            itemKey: 'C',
            itemValue: ''
          },
          {
            itemKey: 'D',
            itemValue: ''
          }
        ]
      }
    },
    resetItemSort () {
      for (let i = 0; i < this.surModel.subjects.length; i++) {
        this.surModel.subjects[i].sort = i
      }
    },
    resetItem () {
      this.questionModel = {
        desc: '',
        sort: 0,
        subjectType: '单选',
        items: [
          {
            itemKey: 'A',
            itemValue: ''
          },
          {
            itemKey: 'B',
            itemValue: ''
          },
          {
            itemKey: 'C',
            itemValue: ''
          },
          {
            itemKey: 'D',
            itemValue: ''
          }
        ]
      }
    },
    redusItem (index) {
      this.questionModel.items.splice(index, 1)
    },
    addNewItem () {
      if (this.questionModel.items.length < 5) {
        let data = {
          itemKey: this.questionArray[this.questionModel.items.length],
          itemValue: ''
        }
        this.questionModel.items.push(data)
      } else {
        this.$commonJs.alertTips({
          type: 'warning',
          title: '提示',
          content: '题目最多添加5个选项',
          stayTime: 5
        })
      }
    },
    addNewSur () {
      this.title = '新建调研'
      this.showModel = true
      this.questionModel = {
        desc: '',
        sort: 0,
        subjectType: '单选',
        items: [
          {
            itemKey: 'A',
            itemValue: ''
          },
          {
            itemKey: 'B',
            itemValue: ''
          },
          {
            itemKey: 'C',
            itemValue: ''
          },
          {
            itemKey: 'D',
            itemValue: ''
          }
        ]
      }
      this.surModel = {
        id: 0,
        researchNo: '',
        researchName: '',
        bu: '',
        product: '',
        customTag: '',
        subjects: [
        ],
        isShowWujiahuiMeeting: true
      }
    },
    saveSur () {
      if (!this.surModel.researchName) {
        return this.$commonJs.alertTips({
          type: 'warning',
          title: '提示',
          content: '请输入调研名称',
          stayTime: 5
        })
      }
      if (this.surModel.subjects.length === 0) {
        return this.$commonJs.alertTips({
          type: 'warning',
          title: '提示',
          content: '未添加问题',
          stayTime: 5
        })
      }
      let url = '/api/Research/create'
      let content = '创建成功'
      if (this.surModel.id !== 0) {
        url = '/api/Research/edit'
        content = '编辑成功'
      }
      this.$axiox.post(url, this.surModel).then(p => {
        this.$commonJs.alertTips({
          type: 'success',
          title: '提示',
          content: content,
          stayTime: 5
        })
        this.getList(1)
        this.showModel = false
      })
    },
    getDetail (item) {
      this.meeting = item
      this.showModel = true
    },
    getList (pageIndex) {
      let data = JSON.parse(JSON.stringify(this.postData))
      data.PageIndex = pageIndex
      let url = this.$commonJs.returnQuery('/api/Research/list', data)
      this.$axiox.getList(url).then(msg => {
        this.myList = msg.data
        this.$emit('getSurId', {researchName: '', id: 0})
        this.selIndex = -1
        this.postData.PageIndex = pageIndex
        this.page = pageIndex
        this.totalPage = Math.ceil(msg.total / this.postData.PageSize)
        this.totalCount = msg.total
      })
    }
  }
}
</script>

<style scoped>
.allSelectedMember{
  padding: 10px 20px;
  border-radius: 10px;
  background: #FEF5F0;
  margin: 10px 0;
  overflow: hidden;
  position: relative;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.allSelectedMember b{
  position: absolute;
  right: 10px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/surveryManager/chooseSurveryList.vue